interface Global {
    bookingAuthToken?: string;
    partnerGUID?: string;
    loadedGA?: boolean;
}

export namespace Global {
    export var bookingAuthToken: string | undefined = undefined;
    export var partnerGUID: string | undefined = undefined;
    export var loadedGA: boolean | undefined = undefined;
}
